


































































































import Vue from "vue";
import Component from "vue-class-component";
import { Model, Emit, Ref, Prop } from "vue-property-decorator";
import AddressInputGroup from "@/components/inputs/AddressInputGroup.vue";
import { auth as authStore, doctor as store } from "@/store/modules";
import { emailRules, phoneNoRules, postalCodeRules, required } from "@/utils/validation";
import { Address } from "cluster";
import { DoctorModel, ExportLock } from "@/models/doctor";
import { inject } from 'inversify-props';
import { IAuthService, IDoctorService, ICenterService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { deepOverwrite } from '@/utils/transformers';

@Component({
  components: {
    AddressInputGroup
  }
})
class DoctorEditor extends Vue {
  @inject(DependencyIdentifiers.DoctorService)
  private doctorService!: IDoctorService;
  @inject(DependencyIdentifiers.CenterService)
  private centerService!: ICenterService;
  @inject(DependencyIdentifiers.AuthService)
  auth!: IAuthService;

  @Ref()
  form: any;
  enabled: boolean = false;
  isPrimaryCenter = false;
  isDeveloperCenter = false;
  isUserManager = authStore.isManager;
  isManager = false;

  get formConfig() {
    return {
      name: {
        label: this.$t('doctor.fields.name'),
        rules: [required]
      },
      contactPhone: {
        label: this.$t('doctor.fields.contactPhone'),
        rules: [required, ...phoneNoRules],
        prefix: "+36"
      },
      contactEmail: {
        label: this.$t('doctor.fields.contactEmail'),
        rules: [required, ...emailRules],
        show: false,
      }
    };
  }

  get exportLockValues() {
    let values = [
      {text: this.$t('doctor.exportLock.none') , value: 'none'},
    ];
    if (this.isDeveloperCenter) {
      values.push({text: this.$t('doctor.exportLock.developer'), value: 'developer'}),
      values.push({text: this.$t('doctor.exportLock.pharmacy'), value: 'pharmacy'});
    } else {
      values.push({text: this.$t('doctor.exportLock.neak'), value: 'neak'});
    }
    return values;
  }

  formData: DoctorModel = {
    name: "",
    contactPhone: "",
    contactEmail: "",
    $centerId: null,
    address: null,
    $isManager: false,
    $exportLock: ExportLock.None
  };

  isLoading = false;

  get disabled() {
    return this.enabled === false;
  }

  get isExportLockDisabled() {
    return this.formData.$isManager;
  }

  @Emit("cancel")
  onCancel() {}

  @Emit("created")
  onCreated(model: DoctorModel) {
    return model;
  }

  @Emit("updated")
  onUpdated(model: DoctorModel) {
    return model;
  }

  @Emit("save")
  onSave(model: DoctorModel) {
    return model;
  }

  @Model("change")
  value!: string;

  @Prop()
  id?: string;

  changeRole(value: boolean) {
    this.isManager = value;
    if (value) {
      this.formData.$exportLock = ExportLock.None;
    }
    this.onChange(value);
  }

  @Emit('changeRole')
  onChange(value: boolean) { return value; }

  async mounted() {
    this.formData.address = null;
    this.enabled = authStore.isManager;
    this.isPrimaryCenter = authStore.isPrimaryCenter;
    this.isDeveloperCenter = (await this.centerService.getById(authStore.currentCenterId||'')).$isDeveloper;
    await this.fetchDoctor();
  }

  async fetchDoctor() {
    if (!this.id) {
      return;
    }
    this.isLoading = true;
    try {
      this.formData = deepOverwrite(
        this.formData,
        await this.doctorService.getById(this.id)
      );
      this.componentKey++;
    } finally {
      this.isLoading = false;
    }
  }

  componentKey = 0;

  async save() {
    if (!this.form.validate()) {
      return;
    }
    this.isLoading = true;
    try {
      this.formData.$centerId = authStore.currentCenterId;
      this.onSave(await this.upsert(this.id, this.formData));
    } finally {
      this.isLoading = false;
    }
  }

  private async upsert(id: any, data: DoctorModel) {
    let model: DoctorModel;
    if (id) {
      model = await this.doctorService.update(id, data);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.onUpdated(model);
    } else {
      model = await this.doctorService.create(data);
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.onCreated(model);
    }
    return model;
  }
}
export default DoctorEditor;
